<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Image URL Generator</h5>
      <br />
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="text-left">
          <b>Create New Image URL Generator</b>
          <b-row class="mt-4">
            <b-col>
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                class="required"
                label="Title"
                label-for="input-1"
              >
                <input
                  v-model="image_url_generator.title"
                  v-validate="'required'"
                  name="title"
                  data-vv-as="Title"
                  id="title"
                  class="form-control"
                  placeholder="Title"
                />
              <b-form-invalid-feedback id="input-title-feedback">{{
                veeErrors.first("title")
              }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="fieldset-1"
                label-class="control-label"
                label="Default Banner"
                label-for="input-1"
              >
                <b-form-select
                  v-model="image_url_generator.default_banner"
                  name="default_banner"
                  v-validate="'required'"
                  data-vv-as="Default Banner"
                >
                  <option
                    v-for="data in option_default_banner"
                    :key="data.value"
                    :value="data.value"
                  >
                    {{ data.text }}
                  </option>
                </b-form-select>
                <p style="width: 100%; margin-top:.25rem; font-size: 80%;color: #e74a3b;">
                  {{ veeErrors.first("default_banner") }}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label-class="control-label"
                class="required"
                label="Image"
                label-for="input-1"
              ></b-form-group>
              <b-card body-class="py-2 px-2">
                <b-row>
                  <b-col class="text-left">
                    <input
                      type="file"
                      ref="fileImage"
                      name="image"
                      data-vv-as="Image"
                      v-validate="
                        !image_url_generator.image
                          ? 'required|ratiolDimensions:2,1|size:2048|ext:jpg,png,jpeg'
                          : 'ratiolDimensions:2,1|size:2048|ext:jpg,png,jpeg'
                      "
                      style="display: none"
                      v-on:change="onChangeFileImage()"
                    />
                    <b-button
                      @click="$refs.fileImage.click()"
                      v-show="!image_url_generator.image && !fileImage"
                      variant="primary"
                      >Pilih File</b-button
                    >
                    <b-button
                      @click="$refs.fileImage.click()"
                      v-show="image_url_generator.image || fileImage"
                      variant="outline-primary"
                      >Ubah File</b-button
                    >
                    <span class="text-secondary ml-1">(Image ratio 2:1 with format JPG/PNG and Max 2MB)</span>
                  </b-col>
                </b-row>
              </b-card>
              <p class="font-weight-bold" style="width: 100%; margin-top:.25rem; font-size: 80%;color: #e74a3b;">
                {{ veeErrors.first("image") }}
              </p>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col md="2" class="text-left">
              <label class="text-danger">
                *
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col>
              <router-link :to="{ name: 'ImageURLGenerator' }">
                <b-button :disabled="loading_form_image_url_generator" class="col-3 mr-3" variant="outline-secondary" size="lg">Cancel</b-button>
              </router-link>
              <b-button
                variant="primary"
                :disabled="loading_form_image_url_generator"
                @click="createImageURLGenerator()"
                class="col-3"
                size="lg"
              >
                Save
                <b-spinner v-if="loading_form_image_url_generator" small label="Loading..."></b-spinner>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card class="text-center" v-if="image_url_generator.image || urlImage">
          <img
            v-show="!fileImage"
            v-if="image_url_generator.image"
            :src="image_url_generator.image"
            class="img-fluid"
          />
          <img
            v-show="fileImage"
            v-if="urlImage"
            :src="urlImage"
            class="img-fluid"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading_form_image_url_generator: false,
      image_url_generator: {
        id: "",
        title: "",
        image: "",
        default_banner: false,
      },
      fileImage: "",
      urlImage: "",
      option_default_banner: [
        {text: "Yes", value: true},
        {text: "No", value: false},
      ]
    } 
  },
  methods: {
    createImageURLGenerator() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_image_url_generator = true;
          const formData = new FormData();
          formData.append("title", this.image_url_generator.title);
          formData.append("default_banner", this.image_url_generator.default_banner);
          formData.append("image", this.fileImage);
          this.$store
            .dispatch("ImageURLGeneratorModule/postImageURLGenerator", formData)
            .then((response) => {
              this.loading_form_image_url_generator = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.$router.push({ name: "ImageURLGenerator" });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store my voucher tab",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_image_url_generator = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    onChangeFileImage() {
      this.fileImage = this.$refs.fileImage.files[0];
      const input = this.$refs.fileImage;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  }
};
</script>